"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Skeleton_1 = tslib_1.__importDefault(require("@mui/material/Skeleton"));
const GridCard_1 = require("./GridCard");
const getStyles = ({ props }) => ({
    root: {
        padding: (theme) => (props.disableGutters ? theme.spacing(0, 0, 2, 0) : theme.spacing(0, 2, 2, 2)),
        height: "100%",
        flexGrow: 1,
        overflow: "auto",
        wordWrap: "normal",
    },
    skeleton: {
        height: "100%",
    },
});
/**
 * This is a component to render the content within a GridCard.
 *
 * @remarks
 *  - This is to be wrapped inside the GridCard component
 *  - This component will catch and handle any errors during rendering and display a generic error component with the error message.
 *  - The developer is responsible for handling any errors outside of rendering, such errors when data fetching.
 *  - Gutters can be disabled
 *
 * @example Basic usage
 * ```tsx
 * <GridCard loading={false}>
 *     <GridCardContent >
 *         <div> This is some content to display in a GridCard </div>
 *     </GridCardContent>
 * </GridCard>
 * ```
 */
const GridCardContent = (props) => {
    const { children, disableGutters = false } = props;
    const styles = getStyles({ props: { disableGutters } });
    const { initializing } = (0, react_1.useContext)(GridCard_1.GridCardContext);
    return (react_1.default.createElement(react_1.default.Fragment, null, initializing ? (react_1.default.createElement(Box_1.default, { sx: styles.root },
        react_1.default.createElement(Skeleton_1.default, { sx: styles.skeleton, variant: "rectangular" }))) : (react_1.default.createElement(Box_1.default, { sx: styles.root }, children))));
};
exports.default = GridCardContent;
